<div *ngIf="environment">
  <div class="stick-top">
    <mat-toolbar>
      <mat-icon>terrain</mat-icon>
      {{
        !environment.id
          ? "Create new Environment"
          : "Environment " + environment.name
      }}
    </mat-toolbar>
    <div class="hbox lightly-padded button-bar">
      <button
        mat-raised-button
        class="primary"
        type="button"
        (click)="save()"
        [disabled]="!form.form.valid"
      >
        <mat-icon>{{ !environment.id ? "add" : "save" }}</mat-icon>
        {{ environment.id ? "Update " : "Add " }}
      </button>
      <micro-delete-confirm
        *ngIf="environment.id"
        (onConfirm)="delete()"
      ></micro-delete-confirm>
    </div>
  </div>

  <div class="padded vbox-space">
    <div>
      <form #form="ngForm" role="form" class="vbox">
        <table class="basicTable vtable">
          <thead>
            <tr>
              <th colspan="100">Environment Configuration</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>
                <micro-valid-label
                  for="name"
                  [model]="name"
                  label="Name"
                ></micro-valid-label>
              </th>
              <td>
                <input
                  #name="ngModel"
                  [(ngModel)]="environment.name"
                  required
                  placeholder="Name"
                  id="name"
                  name="name"
                />
              </td>
            </tr>
            <tr>
              <th>
                <micro-valid-label
                  for="code"
                  [model]="code"
                  label="Code"
                ></micro-valid-label>
              </th>
              <td>
                <input
                  #code="ngModel"
                  [(ngModel)]="environment.code"
                  required
                  maxlength="10"
                  id="code"
                  name="code"
                />
              </td>
            </tr>
            <tr>
              <th>Description</th>
              <td>
                <textarea
                  [(ngModel)]="environment.description"
                  maxlength="200"
                  id="description"
                  name="description"
                  style="min-width: 350px; min-height: 100px"
                ></textarea>
              </td>
            </tr>
            <tr>
              <th [ngClass]="environment.active !== 'Y' ? 'CRITICAL' : ''">
                <micro-valid-label
                  for="active"
                  label="Active"
                ></micro-valid-label>
              </th>
              <td>
                <input
                  type="checkbox"
                  [checked]="environment.active === 'Y'"
                  (change)="onCheckboxChange($event)"
                  id="active"
                  name="active"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </form>
    </div>
  </div>
</div>
